import { create } from "zustand";

export const useHeaderStore = create((set) => ({
  isSidebarMenuOpen: false,

  sidebarMenuOpen: () => {
    set({ isSidebarMenuOpen: true });
  },

  sidebarMenuClose: () => {
    set({ isSidebarMenuOpen: false });
  },
}));